/*
 * mo-bild-felder.js — Maße direkt in der vergrößerten Aufmaßzeichnung eingeben
 * Version 1.0.0 · Stand 01.09.2026
 *
 * Stefan am 01.09.2026, mit Screenshot des Großbilds: „hier die maße
 * zusätzlich eingeben können ist cool und auch mobil."
 *
 * Betrifft die BILD-Konfiguratoren (Fenstergitter, Französische Balkone,
 * Fensterstangen): Dort ist die Aufmaßzeichnung ein gerendertes Foto, über das
 * der Motor eine SVG-Bemaßung legt — „Befestigungsabstand: … mm" oben,
 * „Höhe: … mm" rechts. Bisher konnte man dort nur LESEN; eingetragen wurde in
 * Schritt 2, der im Großmodus verdeckt ist.
 *
 * Für die gezeichnete Handlauf-Skizze gibt es das längst
 * (`mo-hl-felder.js`, Fassung 2.0). Diese Datei überträgt dasselbe auf die
 * Bild-Bemaßung — bewusst als EIGENE Datei, nicht als Erweiterung: Jene hängt
 * an `MO_HL.zustand` und an Pfaden wie „Maße oben.y", die es hier nicht gibt.
 *
 * ═══════════════════════════════════════════════════════════════════════
 * 🔴 DIE VIER FALLEN — alle aus `mo-hl-felder.js` übernommen
 * ═══════════════════════════════════════════════════════════════════════
 * Sie sind dort am 26.08.2026 teuer gelernt worden. Wer hier neu baut, ohne
 * sie zu kennen, baut sie zuverlässig wieder ein:
 *
 *   1. NUR EINMAL BAUEN, danach nur verschieben. Der Renderer baut
 *      `#mo-schritte` bei JEDER Eingabe neu. Wer die Felder dabei mit
 *      abreißt, nimmt dem Kunden mitten im Tippen den Fokus weg — und für
 *      ihn sieht es aus, als nähme das Feld nichts an.
 *   2. DIE SCHICHT HÄNGT NICHT IN DER SKIZZE. Alles darin ist nach dem
 *      nächsten Neubau Geschichte.
 *   3. EIN FELD MIT FOKUS BEKOMMT SEINEN WERT NICHT ÜBERSCHRIEBEN, sonst
 *      springt die Zahl beim Tippen unter den Fingern weg.
 *   4. `<span>` statt `<label>` — ein Label um sein eigenes Input leitet den
 *      Klick ein zweites Mal weiter und zerschießt die Textauswahl.
 *
 * ⭐ Warum HTML über dem SVG und kein `<foreignObject>`: Das skaliert mit der
 * viewBox mit (hier 0 0 800 800). Ein Feld darin wäre klein bei kleiner
 * Zeichnung und riesig im Großmodus. Als HTML darüber behält es seine
 * Schriftgröße — und bleibt damit auf dem Handy bedienbar.
 *
 * ⚠️ NUR IM GROSSMODUS. In der kleinen Zeichnung (rund 250 px) gäbe es keinen
 * Platz für zwei Eingabefelder, und Schritt 2 steht dort ohnehin direkt
 * darunter. Stefan: „nur im Großbild machen."
 */
(function () {
  'use strict';

  /* 🔴 Nie zusammen mit der Handlauf-Feldschicht arbeiten. Dort legt
     `mo-hl-felder.js` bereits Felder über die Zeichnung; zwei Schichten
     übereinander hieße zwei Eingabefelder für dasselbe Maß — und der Kunde
     tippt in eines, während das andere den alten Wert zeigt.

     Das Liquid lädt diese Datei ohnehin nur für die Bild-Konfiguratoren.
     Diese Sperre ist der zweite Riegel, falls jemand die Bedingung dort
     später lockert. */
  if (window.MO_HL_FELDER_V3 || document.querySelector('[data-mo-handlauf-buehne]')) {
    return;
  }

  var schicht = null;      // überlebt jeden Neubau von #mo-schritte
  var felder = {};         // achse -> {kasten, eingabe}
  var geplant = false;
  var nachversuche = 0;

  /* 🔴 `requestAnimationFrame` feuert nicht zuverlässig — in gedrosselten
     Ansichten (Hintergrundreiter, Vorschaufenster) bleibt der Aufruf liegen.
     Am 26.08.2026 im Vorschaufenster gemessen: rAF lief kein einziges Mal.
     Deshalb immer beide Wege anstoßen, der erste gewinnt. */
  function baldTun(fn) {
    var getan = false;
    var einmal = function () { if (getan) return; getan = true; fn(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(einmal);
    setTimeout(einmal, 0);
  }

  /* 🔴 Der Großmodus der BILD-Konfiguratoren ist NICHT `.mo-skizze-gross`.
     Das ist der Großmodus der gezeichneten Handlauf-Skizze.

     Beim Fenstergitter öffnet der Klick auf die Aufmaßzeichnung
     `window.moVollbild.zeigen(url, titel, svg)` — ein eigenes Overlay, das
     Bild UND Maß-SVG hineinkopiert (`mo-konfigurator.js`, Zeile 5681).
     Aufbau:

         .mo-vollbild(.mo-vollbild-an)     ← die Schicht, position:fixed
           .mo-vollbild-kasten
             button.mo-vollbild-zu          ← das ×
             .mo-vollbild-bild              ← Rahmen: img + kopiertes SVG
             .mo-vollbild-text

     Bezugspunkt ist `.mo-vollbild-bild`: Er nimmt exakt die Bildgröße an,
     und das Maß-SVG liegt mit `width:100%` darüber. Am Kasten läge daneben
     auch noch die Beschriftung.

     ⚠️ `.mo-vollbild-an` mitprüfen — die Schicht bleibt nach dem Schließen
     im DOM stehen und ist nur auf `display:none` gesetzt. */
  function grosseSkizze() {
    var voll = document.querySelector('.mo-vollbild.mo-vollbild-an');
    if (!voll) return null;
    return voll.querySelector('.mo-vollbild-bild') || voll;
  }

  /* Das echte Eingabefeld aus Schritt 2. Es bleibt die einzige Wahrheit —
     unsere Felder schreiben nur hinein und lesen daraus. */
  function echtesFeld(achse) {
    return document.querySelector('.mo-massfeld[data-achse="' + achse + '"]');
  }

  /* Der Name der Achse, wie ihn die Bemaßung selbst zeigt
     („Befestigungsabstand", „Höhe"). Aus dem SVG-Text gelesen, damit hier
     nichts doppelt gepflegt werden muss. */
  function achsenName(text) {
    var t = String(text || '').split(':')[0].trim();
    return t || 'Maß';
  }

  /* Die beiden Maßtexte im SVG der Bemaßung. Erkannt am Doppelpunkt und der
     Einheit — nicht an einer festen Reihenfolge: Bei den `onlyX`-Modellen
     (Stange, Handlauf) gibt es nur einen. */
  function masstexte(gross) {
    var svg = gross.querySelector('svg');
    if (!svg) return [];
    return [].slice.call(svg.querySelectorAll('text')).filter(function (t) {
      return /:\s*(…|\d)/.test(t.textContent || '');
    });
  }

  /* Welche Achse gehört zu welchem Text? Über die Ausrichtung: Die Breite
     steht waagerecht, die Höhe ist um -90 Grad gedreht. Das ist stabiler als
     der Wortlaut — „Befestigungsabstand" heißt bei den Balkonen anders. */
  function achseVon(t) {
    return /rotate\(\s*-?90/.test(t.getAttribute('transform') || '') ? 'y' : 'x';
  }

  function bauen(gross) {
    var texte = masstexte(gross);
    if (!texte.length) return false;

    schicht = document.createElement('div');
    schicht.className = 'mo-bildfelder';
    schicht.setAttribute('data-mo-bildfelder', '');
    felder = {};

    texte.forEach(function (t) {
      var achse = achseVon(t);
      if (felder[achse]) return;                 // je Achse nur eines
      var echt = echtesFeld(achse);
      if (!echt) return;                         // ohne Gegenstück kein Feld

      var kasten = document.createElement('div');
      kasten.className = 'mo-bildfeld mo-bildfeld-' + achse;

      /* 🔴 span, nicht label — siehe Falle 4 im Kopf. */
      var name = document.createElement('span');
      name.className = 'mo-bildfeld-name';
      /* MIT Doppelpunkt, genau wie die Beschriftung im Bild: dort steht
         „Befestigungsabstand: 1200 mm". Das Feld tritt an die Stelle des
         Textes und muss ihn ersetzen, nicht danebenstehen. */
      name.textContent = achsenName(t.textContent) + ':';

      var eingabe = document.createElement('input');
      eingabe.type = 'text';
      /* `inputmode` statt `type=number`: Auf dem Handy kommt die Zahlen-
         tastatur, aber ohne die Spinner-Pfeile und ohne das Scrollrad-
         Verstellen, das bei `number` schon Maße verändert hat. */
      eingabe.inputMode = 'numeric';
      eingabe.autocomplete = 'off';
      eingabe.className = 'mo-bildfeld-eingabe';
      /* 🔴 ALS PLATZHALTER DIE DREI PUNKTE — nicht die Beispielzahl.

         Zwei Anläufe, beide am Bild verworfen:
           „z. B. 1300"  →  im schmalen Feld abgeschnitten zu „z. B. 13",
                            das liest sich wie ein kaputter Wert.
           „1300"        →  sieht aus wie ein EINGETRAGENES Maß. Am
                            01.09.2026 im Bild: oben „1200 mm" (echt),
                            rechts „1300 mm" (Platzhalter) — nicht zu
                            unterscheiden, während der Preis „Höhe fehlt"
                            meldete. Bei Maßanfertigung ohne Widerrufsrecht
                            ist das die gefährlichere Art von Fehler.

         Das Original zeigt bei leerem Wert „Höhe: … mm". Genau das steht
         jetzt hier — die Optik von vorher, auch im leeren Zustand. */
      eingabe.placeholder = '…';
      eingabe.value = echt.value || '';
      eingabe.setAttribute('aria-label', name.textContent);

      var einheit = document.createElement('span');
      einheit.className = 'mo-bildfeld-einheit';
      einheit.textContent = einheitJetzt();

      kasten.appendChild(name);
      kasten.appendChild(eingabe);
      kasten.appendChild(einheit);
      schicht.appendChild(kasten);

      /* Tippen wird sofort weitergereicht: dasselbe Ereignis, das auch das
         echte Feld auslöst, damit Preis, Zeichnung und Kaufknopf mitziehen. */
      eingabe.addEventListener('input', function () {
        var e = echtesFeld(achse);
        if (!e || e.value === eingabe.value) return;
        e.value = eingabe.value;
        e.dispatchEvent(new Event('input', { bubbles: true }));
      });
      /* `change` erst beim Verlassen — der Motor rechnet dort die Grenzen
         nach und würde sonst schon bei „1" auf „mindestens 300" meckern. */
      eingabe.addEventListener('change', function () {
        var e = echtesFeld(achse);
        if (!e) return;
        e.value = eingabe.value;
        e.dispatchEvent(new Event('change', { bubbles: true }));
      });
      eingabe.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); eingabe.blur(); }
      });

      felder[achse] = { kasten: kasten, eingabe: eingabe, einheit: einheit };
    });

    if (!Object.keys(felder).length) { schicht = null; return false; }

    /* 🔴 Ohne Bezugsrahmen rechnet `position:absolute` gegen das nächste
       positionierte Element weiter oben — die Felder landen dann in der
       Seitenecke statt im Bild. Ein vergessenes `position:relative` fällt
       erst beim Kunden auf; dieselbe Zeile steht aus demselben Grund in
       `mo-hl-felder.js`. */
    if (getComputedStyle(gross).position === 'static') {
      gross.style.position = 'relative';
    }

    gross.appendChild(schicht);
    return true;
  }

  function einheitJetzt() {
    try {
      var an = document.querySelector('.mo-einheit-knopf.mo-an');
      if (an) return /cm/i.test(an.textContent) ? 'cm' : 'mm';
      if (localStorage.getItem('mo-einheit') === 'cm') return 'cm';
    } catch (e) {}
    return 'mm';
  }

  /* Die Felder an ihre Maßtexte schieben. Gerechnet wird gegen die
     vergrößerte Skizze, nicht gegen das Fenster — sie ist `position:fixed`,
     ihre eigene linke obere Ecke ist der Nullpunkt. */
  function stellen() {
    var gross = grosseSkizze();
    if (!gross || !schicht) return;

    /* ⭐ DIE OPTIK DER BEMASSUNG WIRD ÜBERNOMMEN, NICHT NEU ERFUNDEN.

       Stefan am 01.09.2026: „bei der maß eingabe der großbilder die optik von
       vorher behalten sonst nicht machen." Das Feld tritt an die Stelle der
       Maßbeschriftung — also muss es aussehen wie sie.

       Am 01.09.2026 am gerenderten SVG abgelesen (nicht geschätzt):

           Schrift   Montserrat, 700, font-size 26   (SVG-Einheiten)
           Farbe     #cb4f0a
           Kasten    rect fill #fff, stroke #cb4f0a, rx 7.15

       🔴 Die SVG-Einheiten sind KEINE Pixel. Der viewBox ist 800 breit, das
       Vollbild war 1073 px — Faktor 1,341, aus 26 werden also 34,9 px. Und
       der Faktor ändert sich mit der Fenstergröße: auf dem Handy war das
       Bild 327 px breit, Faktor 0,41. Fest verdrahtete Pixelwerte wären mal
       riesig, mal unlesbar. Deshalb wird bei jedem `stellen()` neu
       gerechnet. */
    var svg = gross.querySelector('svg');
    var vb = svg && (svg.getAttribute('viewBox') || '').split(/[\s,]+/);
    var faktor = 1;
    if (svg && vb && vb.length === 4) {
      var vbBreite = parseFloat(vb[2]);
      var istBreite = svg.getBoundingClientRect().width;
      if (vbBreite > 0 && istBreite > 0) faktor = istBreite / vbBreite;
    }
    var schrift = Math.max(11, 26 * faktor);      // nie unter lesbar
    Object.keys(felder).forEach(function (achse) {
      var f = felder[achse];
      f.kasten.style.fontSize = schrift.toFixed(1) + 'px';
      f.kasten.style.borderRadius = (7.15 * faktor).toFixed(1) + 'px';
      f.kasten.style.padding = (3 * faktor).toFixed(1) + 'px ' +
                               (9 * faktor).toFixed(1) + 'px';
      f.kasten.style.borderWidth = Math.max(1, 1.6 * faktor).toFixed(1) + 'px';
      f.kasten.style.gap = (5 * faktor).toFixed(1) + 'px';
      /* Die Eingabe ist so breit wie ihr längster erwarteter Wert — vier
         Ziffern. `ch` folgt der Schriftgröße von allein. */
      f.eingabe.style.width = '4.4ch';
    });

    var bezug = gross.getBoundingClientRect();
    if (!bezug.width || !bezug.height) {
      /* Der Browser liefert beim Umschalten kurz 0x0. Nicht aufgeben,
         sondern ein paar Anläufe geben — sonst stehen die Felder in der
         Ecke, und zwar dauerhaft. */
      if (nachversuche++ < 10) setTimeout(stellen, 40);
      return;
    }
    nachversuche = 0;

    masstexte(gross).forEach(function (t) {
      var achse = achseVon(t);
      var f = felder[achse];
      if (!f) return;
      var r = t.getBoundingClientRect();
      if (!r.width && !r.height) return;

      /* 🔴 Der Maßtext im Vollbild wird AUSGEBLENDET, wo ein Feld liegt.
         Am 01.09.2026 gemessen: Das Feld deckte „Befestigungsabstand: … mm"
         nur zur Hälfte ab — links stand „Befesti", rechts „… mm", dazwischen
         das Feld. Das las sich wie ein Anzeigefehler.

         Ausgeblendet wird nur die KOPIE im Vollbild; die Bemaßung in der
         kleinen Zeichnung bleibt unangetastet. Und `visibility` statt
         `display`, damit `getBoundingClientRect()` weiter die Stelle
         liefert, an der das Feld stehen soll.

         ⚠️ Der Text allein genügt nicht: Jeder Maßtext hat einen weißen
         Hintergrundkasten, der unmittelbar davor steht — gemessen ist die
         Reihenfolge im SVG `…,rect,text,…,rect,text`. Bliebe er stehen,
         läge ein leerer weißer Balken quer über der Maßlinie. */
      t.style.visibility = 'hidden';
      var kasten = t.previousElementSibling;
      if (kasten && kasten.tagName.toLowerCase() === 'rect') {
        kasten.style.visibility = 'hidden';
      }

      var mitteX = r.left + r.width / 2 - bezug.left;
      var mitteY = r.top + r.height / 2 - bezug.top;

      /* Das Höhenfeld steht HOCHKANT, wie die Beschriftung, die es ersetzt
         (Stefan, 01.09.2026: „höhe hochkant finde ich persönlich besser?").
         Die Drehung macht das CSS über `.mo-bildfeld-seitlich`; hier wird nur
         die Mitte gesetzt — gedreht wird um genau diesen Punkt. */
      f.kasten.style.left = mitteX + 'px';
      f.kasten.style.top = mitteY + 'px';
      f.kasten.classList.toggle('mo-bildfeld-seitlich', achse === 'y');
    });
  }

  /* Werte nachziehen, ohne dem Tippenden die Zahl wegzunehmen (Falle 3). */
  function werteAngleichen() {
    Object.keys(felder).forEach(function (achse) {
      var f = felder[achse];
      var e = echtesFeld(achse);
      if (!f || !e) return;
      if (document.activeElement !== f.eingabe && f.eingabe.value !== e.value) {
        f.eingabe.value = e.value;
      }
      if (f.einheit) f.einheit.textContent = einheitJetzt();
    });
  }

  function angleichen() {
    if (geplant) return;
    geplant = true;
    baldTun(function () {
      geplant = false;
      var gross = grosseSkizze();

      if (!gross) {                      // klein: Schicht abräumen
        if (schicht && schicht.parentNode) schicht.parentNode.removeChild(schicht);
        schicht = null; felder = {};
        return;
      }
      /* Neu bauen nur, wenn es die Schicht nicht gibt oder sie in einer
         anderen (alten) Skizze hängt — sonst nur verschieben. Falle 1. */
      if (!schicht || schicht.parentNode !== gross) {
        if (schicht && schicht.parentNode) schicht.parentNode.removeChild(schicht);
        schicht = null;
        if (!bauen(gross)) return;
      }
      werteAngleichen();
      stellen();
    });
  }

  /* Der Motor baut den Schrittbereich bei jeder Eingabe neu; das SVG der
     Bemaßung ist danach ein anderes Element. Ein Beobachter am Dokument
     merkt das, ohne dass der Motor uns kennen muss. */
  var beobachter = new MutationObserver(function () { angleichen(); });
  try {
    beobachter.observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class']
    });
  } catch (e) {}

  window.addEventListener('resize', angleichen);
  window.addEventListener('orientationchange', angleichen);
  document.addEventListener('DOMContentLoaded', angleichen);
  angleichen();

  window.MO_BILD_FELDER = { angleichen: angleichen, stellen: stellen };
})();
